var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CreditCard',{class:'credit-card--' + _vm.name,attrs:{"image-url":_vm.imageUrl,"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }